import { portalHttpClient, suppressErrorAlert } from "@/services/httpClient";

const END_POINT = "api/customerPortal/v1/loginActivity";

/**
 * Recorded on every account the grower opens, including a switch part way through a session. The portal only
 * writes activity; the history itself is read in Merchant Ag.
 */
//The caller swallows a failure here on purpose, so the generic alert is suppressed as well - a banner
//saying "Request failed" over a working page is the surfacing the audit is meant not to do.
export async function recordAccountSelection(): Promise<void> {
  await portalHttpClient.post(
    `${END_POINT}/accountSelection`,
    undefined,
    suppressErrorAlert
  );
}
